<template>
  <div class="video-relook">
    <div id="xgPlayer" class="xgPlayer"></div>

    <div class="button-con" @click="goMore">
      <span>查看更多精彩内容</span>
    </div>

    <get-shop-info :title="'直播回放'"/>
  </div>
</template>

<script>
import { getVideoFileByVid } from '@/api/im'
import GetShopInfo from '@/components/getShopInfo'
import { mapGetters } from 'vuex'
export default {
  components: {
    GetShopInfo,
  },
  data(){
    return {
      player: null,//播放器实例
      playerConfig: {
        id: "xgPlayer",
        width: '100%',
        height: '100%',
        "playsinline": false, // 内联模式(微信播放器)
        "whitelist": [""],
        "playbackRate": [0.5, 1, 1.5, 2],
        "closeVideoTouch": true,
        "x5-video-player-type": "h5", // 微信同层播放: h5
        // "x5-video-player-fullscreen": "true", // 微信全屏播放： true  false
        // "x5-video-orientation": "portraint", //微信横竖屏控制：横屏 landscape, 竖屏 portraint
      },
    }
  },
  computed:{
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created(){
    if(this.$route.query.vid){
      this.getVideoFiles()
    }
  },
  methods:{
    getVideoFiles(){
      getVideoFileByVid({vid: this.$route.query.vid}).then(res=>{
        if(res.code===200){
          document.title = res.data.videoName
          if(res.data.origurl){
            let cover = res.data.coverPhotoUrl ? this.checkQiNiuUrl(res.data.coverPhotoUrl) : '';
            this.initPlayer(res.data.origurl, cover)
          }
        }
      })
    },


    // 初始化播放器
    initPlayer(url, poster){
      this.playerConfig = {
        ...this.playerConfig,
        url,
        poster,
        height: document.body.clientHeight-40,
      };
      this.player = new Player(this.playerConfig);
      // this.player = new HlsJsPlayer(this.playerConfig);
      // this.player = new FlvJsPlayer(this.playerConfig);
    },

    goMore(){
      this.$router.push({name: '5gLive', query: {shopId: this.$route.query.shopId, tab: '2'}})
    },
  },
  beforeDestroy(){
    this.player && typeof this.player.destroy === 'function' && this.player.destroy();
  }
}
</script>

<style lang="less" scoped>
.video-relook{
  position: absolute;z-index: 1;
  width: 100%;height: 100%;
  top: 0;left: 0;bottom: 0;

  .button-con{
    display: flex;justify-content: center;align-items: center;
    height: 40px;user-select: none;
    position: absolute;bottom: 0;left: 0;right: 0;
    background-color: #02C801;
    color: #fff;
    font-size: 15px;
  }
}
</style>